export default {"src":"/_next/static/media/vercel.3c8eefce.svg","height":64,"width":283,"blurWidth":0,"blurHeight":0};